exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content.settings-journey-id,\n.page-content.settings-journey {\n    max-width: 100%;\n}\n", ""]);

// exports
